import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ToastrModule } from 'ngx-toastr';
import { PipesModule } from './theme/pipes/pipes.module';
import { AppRoutingModule } from './app-routing.module';
import { AppSettings } from './app.settings';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { HeaderComponent } from './theme/components/header/header.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { SidebarComponent } from './theme/components/sidebar/sidebar.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { BackTopComponent } from './theme/components/back-top/back-top.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { GridModule, PdfExportService } from '@syncfusion/ej2-angular-grids';
import { NgSelectModule } from '@ng-select/ng-select';
import { GlobalComponent } from './global/global.component';
import { CommonHttpService } from './common.service';
import { CanDeactivateGuard } from 'src/app/service/deactivate.service';
import { AgmCoreModule } from '@agm/core';
import { AuthService } from './auth.service';
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { PagesModule } from './pages/pages.module';
import { PageNotMatchComponent } from './pages/page-not-match/page-not-match.component';
import { ClaimProcessComponent } from './theme/components/claim-process/claim-process.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment.dev';
import {  ApmModule, ApmService } from '@elastic/apm-rum-angular'

import { NgxUiLoaderModule } from 'ngx-ui-loader';
const configFactory = (config: ConfigurationService) => {
  return () => {
    return config.loadConfiguration();
  }
}
@NgModule({
  imports: [
    HttpClientModule,
    HttpClientJsonpModule,
    CurrencyMaskModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    PerfectScrollbarModule,
    NgbModule,
    DragDropModule,
    NgxChartsModule,
    MultiselectDropdownModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAir4tXhx3X-wcdZnhe8TLlo9J2m_AKx6w'
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    ToastrModule.forRoot(),
    PipesModule,
    PagesModule,
    AppRoutingModule,
    ApmModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgxUiLoaderModule
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    BackTopComponent,
    FullScreenComponent,
    UserMenuComponent,
    PageNotMatchComponent,
    ClaimProcessComponent
  ],
  providers: [
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      multi: true,
      deps: [ConfigurationService]
    },
    CanDeactivateGuard,
    AppSettings,
    DatePipe,
    ApmService,
    GlobalComponent,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthService,
      multi: true,
    },
    CommonHttpService,
    PdfExportService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: LocationStrategy, useClass: HashLocationStrategy, }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
    constructor(service: ApmService) {
        const apm = service.init({
          serviceName:'apm-fmswebui',
          serverUrl: 'https://apmrum.allcaresoftware.com',
          environment: environment.environment,
          logLevel: 'debug',  
        })
      }
}
